module.exports = __webpack_public_path__ + "img/atch.3af7bcee.jpg";